import { useTranslation } from "react-i18next"
import { ComboEntity } from "../../Objects/Combo/ComboEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useGetCombo } from "./useGetCombo"

export const useSaveCombo = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetCombo } = useGetCombo()

  const handleSaveCombo = async (combo: ComboEntity, onSuccess: any, imageFile?: Blob | File | null) => {
    try {
      enableLoad()

      const response =
        combo.id !== -1
          ? await PutFormRequest(`${API_ROUTES.COMBO.PUT}/${combo.id}`, combo.toJSON(imageFile || undefined))
          : await PostFormRequest(API_ROUTES.COMBO.CREATE, combo.toJSON(imageFile || undefined))

      if (response.success) {
        await handleGetCombo(onSuccess)

        return
      }

      throw new Error(response.message)

    } catch (e) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleSaveCombo }
}
